/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Ribbon16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M13 1a1 1 0 01.993.883L14 2v12a1 1 0 01-1.413.911l-.101-.054L8 12l-4.486 2.857a1.001 1.001 0 01-1.488-.627l-.02-.116L2 14V2a1 1 0 01.883-.993L3 1h10zM8.34 4.224a.368.368 0 00-.635-.074l-.045.074-.718 1.513-1.613.244c-.29.044-.42.403-.26.645l.052.063 1.158 1.173-.273 1.653c-.05.309.22.553.483.468l.066-.028L8 9.165l1.445.79c.26.142.555-.068.555-.364l-.006-.076-.273-1.653 1.158-1.173c.214-.217.127-.591-.133-.688l-.075-.02-1.612-.244-.72-1.513zM2 15V1"
        />
    </AccessibleSVG>
);

export default Ribbon16;
